import React from 'react';
import Skeleton from './Skeleton';
import './VideoEditSkeleton.scss';

interface VideoEditSkeletonProps {
  className?: string;
}

const VideoEditSkeleton: React.FC<VideoEditSkeletonProps> = ({
  className = ''
}) => {
  return (
    <div className={`video-edit-skeleton ${className}`}>
      {/* 顶部标题栏骨架屏 */}
      <div className="caozuo-title-skeleton">
        <Skeleton width="40px" height="20px" variant="rectangular" animation="pulse" />
        <Skeleton width="120px" height="16px" variant="text" animation="wave" />
      </div>

      {/* 主要内容区域骨架屏 */}
      <main className="video-edit-content-skeleton">
        {/* 左侧视频预览区域 */}
        <div className="video-left-skeleton">
          {/* 顶部标题 */}
          <div className="top-skeleton">
            <Skeleton width="80px" height="16px" variant="text" animation="pulse" />
          </div>

          {/* 视频播放区域 */}
          <div className="video-show-skeleton">
            <div className="video-show-left-skeleton">
              <Skeleton width="100%" height="100%" variant="rectangular" animation="wave" />
            </div>
            <div className="video-show-right-skeleton">
              <Skeleton width="100%" height="100%" variant="rectangular" animation="wave" />
            </div>
          </div>

          {/* 播放控制区域 */}
          <div className="bofang-skeleton">
            <div className="custom-player-controls-skeleton">
              <Skeleton width="40px" height="40px" variant="circular" animation="pulse" />
              <Skeleton width="50px" height="16px" variant="text" animation="pulse" />
              <Skeleton width="200px" height="8px" variant="rectangular" animation="wave" />
              <Skeleton width="50px" height="16px" variant="text" animation="pulse" />
            </div>
          </div>
        </div>

        {/* 右侧台词编辑区域 */}
        <div className="video-right-skeleton">
          {/* 顶部标题 */}
          <div className="top-skeleton">
            <Skeleton width="80px" height="16px" variant="text" animation="pulse" />
          </div>

          {/* 语言标签区域 */}
          <div className="video-title-skeleton">
            <Skeleton width="60px" height="16px" variant="text" animation="pulse" />
            <Skeleton width="40px" height="16px" variant="text" animation="pulse" />
          </div>

          {/* 台词列表区域 */}
          <div className="text-list-skeleton">
            {Array.from({ length: 8 }, (_, index) => (
              <div key={index} className="row-item-skeleton">
                {/* 时间范围 */}
                <div className="time-range-skeleton">
                  <Skeleton width="120px" height="12px" variant="text" animation="pulse" />
                </div>

                {/* 源语言台词 */}
                <div className="source-text-skeleton">
                  <Skeleton width="100%" height="16px" variant="text" animation="wave" />
                  <Skeleton width="80%" height="16px" variant="text" animation="wave" />
                </div>

                {/* 角色选择器 */}
                <div className="role-selector-skeleton">
                  <Skeleton width="80px" height="32px" variant="rectangular" animation="pulse" />
                </div>

                {/* 目标语言台词 */}
                <div className="target-text-skeleton">
                  <Skeleton width="100%" height="16px" variant="text" animation="wave" />
                  <Skeleton width="70%" height="16px" variant="text" animation="wave" />
                </div>

                {/* 操作按钮 */}
                <div className="action-buttons-skeleton">
                  <Skeleton width="24px" height="24px" variant="circular" animation="pulse" />
                  <Skeleton width="24px" height="24px" variant="circular" animation="pulse" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
};

export default VideoEditSkeleton;
